import { DELIMITER } from 'app/shared/constants/AnalyticsDelimiterConstants';

const WILL_GET_CUSTOM_DATA = true;

const PAYMENT_TYPE = {
    FAST_PAYOUT: 'FastPayout',
    ONE_TIME_PAYMENT: 'OneTimePayment',
    RECURRING_PAYMENT: 'RecurringPayment',
};

const PAYMENT_STATUS = {
    FAILED: 'Failed',
    PAID: 'Paid',
    PAID_OFFLINE: 'PaidOffline',
    PAST_DUE: 'PastDue',
    PROCESSING: 'Processing',
    REQUESTED: 'Requested',
    RETURNED: 'Returned',
    SENT: 'Sent',
};

const CATEGORY = `ManageTenants${DELIMITER}Payments`;

const LABEL = {
    CLICK: 'Click',
    LABEL_CLICK: 'LabelClick',
    OUTBOUND_CLICK: 'OutboundClick',
};

const GA_PREFIX = {
    EXPAND_PAYMENT_DETAILS: 'ExpandPaymentDetails',
    COLLAPSE_PAYMENT_DETAILS: 'CollapsePaymentDetails',
    MESSAGE_TENANT: 'MessageTenant',
    EMAIL_CUSTOMER_SUPPORT: 'EmailCustomerSupport',
    CANCEL_PAYMENT: 'CancelPayment',
    ADD_LATE_FEE: 'AddALateFee',
    UPDATE_DEPOSIT_ACCOUNT: 'UpdateDepositAccount',

};

const GA_SUFFIX = {
    TEXT_LINK: 'TextLink',
};

const GA_EVENTS = {
    // empty state
    GET_STARTED_EMPTY_STATE_CLICK: {
        category: CATEGORY,
        label: LABEL.LABEL_CLICK,
        action: 'StartCollectingRent',
    },
    LEARN_MORE_EMPTY_STATE_CLICK: {
        category: CATEGORY,
        label: LABEL.OUTBOUND_CLICK,
        action: `PaymentsLearnMore${DELIMITER}EmptyState`,
    },
    // individual payment
    EXPAND_PAYMENT_DETAILS_CLICK: {
        category: CATEGORY,
        label: LABEL.CLICK,
        // ExpandPaymentDetails::[payment_type]::[payment_status]
        action: WILL_GET_CUSTOM_DATA,
    },
    COLLAPSE_PAYMENT_DETAILS_CLICK: {
        category: CATEGORY,
        label: LABEL.CLICK,
        // CollapsePaymentDetails::[payment_type]::[payment_status]
        action: WILL_GET_CUSTOM_DATA,
    },
    PAYMENT_CTA_CLICK: {
        category: CATEGORY,
        label: LABEL.CLICK,
        // [cta_content]::[payment_type]::[payment_status]
        // message tenant, email support, update deposit account,
        // add one-time payment, add late fee, cancel payment, view all payments
        action: WILL_GET_CUSTOM_DATA,
    },
    // [cta_content]::TextLink
    // view all payments
    PAYMENT_TEXT_CTA_CLICK: {
        category: CATEGORY,
        label: LABEL.CLICK,
        action: WILL_GET_CUSTOM_DATA,
    },
    MANAGE_TENANT_TERMS_CLICK: {
        category: CATEGORY,
        label: LABEL.CLICK,
        action: 'ManageTenantTerms',
    },
    ADD_ONE_TIME_PAYMENT_CLICK: {
        category: CATEGORY,
        label: LABEL.CLICK,
        action: 'AddOneTimePayment',
    },
};

export {
    GA_EVENTS,
    GA_PREFIX,
    GA_SUFFIX,
    PAYMENT_STATUS,
    PAYMENT_TYPE,
};
